import * as BECaller from '../../util/apiCaller';
import { listAll } from '../../components/DashboardSelector/DashboardSelectorActions';
import { setError, setSuccessMessage } from '../App/ErrorsActions';
import urlHelper from '../../util/url';
import { saveCsv } from '../../util/dashboards';
import { trackDashboardActivityExport } from '../../util/mixpanel';

export const DASHBOARDS = 'DASHBOARDS_DASHBOARDS',
  LOADING = 'DASHBOARDS_LOADING';

export function error(err) {
  return setError(err);
}

let options = {};

export function exportCsv(opt = {}) {
  if (!_.isEmpty(opt)) {
    options = opt;
  }

  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    let url = 'dashboards';
    url += urlHelper.buildQuery(options);

    BECaller.api(url, 'get').then(
      data => {
        try {
          saveCsv(data.results);

          trackDashboardActivityExport();

          dispatch(setSuccessMessage('Dashboards export completed.'));
        } catch (err) {
          dispatch(setError('Dashboards export failed.'));
        }
        dispatch({
          type: LOADING,
          val: false
        });
      },
      err => {
        dispatch(setError(err));
      }
    );
  };
}

export function deleteDashboard(dashboardId) {
  return dispatch => {
    return BECaller.api(`dashboards/${dashboardId}`, 'delete').then(
      () => {
        dispatch(getDashboards());
        dispatch(listAll());
      },
      err => {
        dispatch(setError(err));
      }
    );
  };
}

export function getDashboards(opt = {}) {
  if (!_.isEmpty(opt)) {
    options = opt;
  }

  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    let url = 'dashboards';
    url += urlHelper.buildQuery(options);

    BECaller.api(url, 'get').then(
      data => {
        dispatch({
          type: DASHBOARDS,
          data
        });
      },
      err => {
        dispatch(setError(err));
      }
    );
  };
}
